"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewBuildState = exports.ViewScene = exports.ViewPackageQuality = void 0;
var ViewPackageQuality;
(function (ViewPackageQuality) {
    ViewPackageQuality["Low"] = "Low";
    ViewPackageQuality["Medium"] = "Medium";
    ViewPackageQuality["High"] = "High";
    ViewPackageQuality["Ultra"] = "Ultra";
})(ViewPackageQuality = exports.ViewPackageQuality || (exports.ViewPackageQuality = {}));
var ViewScene;
(function (ViewScene) {
    ViewScene["Day"] = "Day";
    ViewScene["Night"] = "Night";
})(ViewScene = exports.ViewScene || (exports.ViewScene = {}));
var ViewBuildState;
(function (ViewBuildState) {
    ViewBuildState["Default"] = "Default";
    ViewBuildState["InPreparation"] = "InPreparation";
    ViewBuildState["InDevelopment"] = "InDevelopment";
    ViewBuildState["Ready"] = "Ready";
})(ViewBuildState = exports.ViewBuildState || (exports.ViewBuildState = {}));
//# sourceMappingURL=View.enums.js.map